import {
  Credential,
  CredentialEntity,
  CredentialEntityToCredentialMapper,
  Logger,
  ServiceProviderMap,
} from '@uploadcam/common';
import { CREDENTIALS_KEY } from './login-with-popup.interactor';
import { Subject } from 'rxjs';

export class RefreshCredentialError extends Error {
  constructor() {
    super();
    this.name = 'RefreshCredentialError';
  }
}

export interface RefreshCredentialAdapterInteractor {
  /**
   * Given a `Credential` returns a refreshed one.
   */
  execute(credential: Credential): Promise<CredentialEntity>;
}

export class RefreshCredentialInteractor {
  private readonly mapper = new CredentialEntityToCredentialMapper();

  constructor(
    private readonly logger: Logger,
    private readonly refreshCredentialError$ = new Subject<void>(),
    private readonly refreshProviders: ServiceProviderMap<RefreshCredentialAdapterInteractor>,
    private readonly storage: Storage,
  ) {}

  public async execute(credential: Credential): Promise<Credential> {
    try {
      const refreshCredential = this.refreshProviders[credential.provider];
      const newCredential: CredentialEntity = {
        ...(await refreshCredential.execute(credential)),
        metadata: credential.metadata,
      };

      this.storage.setItem(CREDENTIALS_KEY, JSON.stringify(newCredential));

      return this.mapper.map(newCredential);
    } catch (err) {
      this.logger.warn('Error refreshing credential:', err);
      this.refreshCredentialError$.next();

      throw new RefreshCredentialError();
    }
  }
}
